import React from 'react';
import { MessageCircle, FileText, Monitor, CreditCard, Paintbrush, Globe, HeadphonesIcon } from 'lucide-react';
import { SectionDivider } from './SectionDivider';
const steps = [{
  number: '01',
  title: 'Contact Us',
  description: 'Reach out via WhatsApp or our contact form. Tell us about your business and what you need.',
  icon: MessageCircle
}, {
  number: '02',
  title: 'Fill Out the Brief & Send Files',
  description: 'Complete a short questionnaire and send us your logo, text, images, and any preferences.',
  icon: FileText
}, {
  number: '03',
  title: 'We Build Your Demo',
  description: 'We design and build a live demo of your website so you can see it before committing.',
  icon: Monitor
}, {
  number: '04',
  title: 'Pay & Confirm',
  description: "Once you're happy with the demo, pay 100% of the discounted price using our secure payment methods.",
  icon: CreditCard
}, {
  number: '05',
  title: 'Final Touches Together',
  description: "We refine the details with you — copy tweaks, image swaps, colour adjustments — until it's perfect.",
  icon: Paintbrush
}, {
  number: '06',
  title: 'Go Live on Your Domain',
  description: 'We connect the site to your existing domain, or purchase a new one for you for a small extra fee.',
  icon: Globe
}, {
  number: '07',
  title: '1 Year of Support',
  description: 'Learn how to use MagicPatterns to edit your site, update content, add features, and much more — with our direct support.',
  icon: HeadphonesIcon
}];
export function HowItWorksSection() {
  return <section id="how-it-works" className="py-16 md:py-24 px-4 md:px-6" style={{
    backgroundColor: '#050505'
  }} data-id="element-291">
      <div className="max-w-5xl mx-auto" data-id="element-292">
        <div className="text-center mb-16 reveal" data-id="element-293">
          <div className="inline-flex items-center space-x-2 bg-[#c9a84c]/10 border border-[#c9a84c]/30 rounded-full px-4 py-1.5 mb-4" data-id="element-294">
            <span className="text-[#c9a84c] text-sm font-medium" data-id="element-295">
              Simple 7-Step Process
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-296">
            How It Works
          </h2>
          <p className="text-white/60 max-w-xl mx-auto" data-id="element-297">
            From first contact to a live website — here's exactly what happens
            when you work with us.
          </p>
        </div>

        <div className="relative" data-id="element-298">
          {/* Vertical line connector */}
          <div className="absolute left-6 md:left-8 top-0 bottom-0 w-px bg-gradient-to-b from-[#c9a84c]/50 via-[#c9a84c]/20 to-transparent hidden md:block" data-id="element-299"></div>

          <div className="space-y-6 md:space-y-8" data-id="element-300">
            {steps.map((step, idx) => {
            const Icon = step.icon;
            return <div key={idx} className="relative flex items-start space-x-5 md:space-x-8 reveal" style={{
              transitionDelay: `${idx * 80}ms`
            }} data-id="element-301">
                  {/* Step number circle */}
                  <div className="relative z-10 flex-shrink-0 w-12 h-12 md:w-16 md:h-16 rounded-full border-2 border-[#c9a84c]/50 flex items-center justify-center" style={{
                backgroundColor: '#0a0a0a'
              }} data-id="element-302">
                    <Icon className="w-5 h-5 md:w-6 md:h-6 text-[#c9a84c]" data-id="element-303" />
                  </div>

                  {/* Content card */}
                  <div className="flex-1 border border-white/[0.06] rounded-xl p-5 md:p-6 hover:border-[#c9a84c]/20 transition-colors" style={{
                backgroundColor: 'rgba(255, 255, 255, 0.02)'
              }} data-id="element-304">
                    <div className="flex items-center space-x-3 mb-2" data-id="element-305">
                      <span className="text-[#c9a84c] text-xs font-bold uppercase tracking-wider" data-id="element-306">
                        Step {step.number}
                      </span>
                      <h3 className="text-white font-bold text-lg" data-id="element-307">
                        {step.title}
                      </h3>
                    </div>
                    <p className="text-white/60 text-sm leading-relaxed" data-id="element-308">
                      {step.description}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </div>

        {/* CTA after steps */}
        <div className="text-center mt-12 reveal" data-id="element-309">
          <p className="text-white/50 text-sm mb-4" data-id="element-310">Ready to get started?</p>
          <a href="https://wa.me/36707559881?text=Hi%2C%20I%27m%20in%20Dublin.%20I%20want%20the%20%E2%82%AC249%20website%20package.%20My%20business%20is%3A%20____" target="_blank" rel="noopener noreferrer" className="inline-flex items-center space-x-2 bg-[#25D366] hover:bg-[#20bd5a] text-white px-8 py-3.5 rounded-lg font-bold transition-all transform hover:scale-[1.02] shadow-lg shadow-green-900/20" data-id="element-311">
            <MessageCircle className="w-5 h-5" data-id="element-312" />
            <span data-id="element-313">Start on WhatsApp</span>
          </a>
        </div>
      </div>
      <SectionDivider data-id="element-314" />
    </section>;
}